import type { ReactNode } from 'react';

import { Card } from '@/design-system';

export interface ReportStateCardProps {
    tone: 'default' | 'accent' | 'warn';
    title: string;
    children: ReactNode;
    /** `status` voor wat vanzelf verandert, `alert` voor wat mislukte. */
    role?: 'status' | 'alert';
    action?: ReactNode;
}

/**
 * Eén rustige mededeling in plaats van het document: nog geen rapport, het
 * concept wordt gemaakt, of het maken mislukte. Geen animatie - die is
 * voorbehouden aan de synchronisatie-indicator.
 */
export function ReportStateCard({ tone, title, children, role, action }: ReportStateCardProps) {
    const ink = tone === 'warn' ? 'text-[var(--warn-ink)]' : 'text-[var(--text-primary)]';
    const body = tone === 'warn' ? 'text-[var(--warn-ink)]' : 'text-[var(--text-secondary)]';

    return (
        <Card variant={tone} padding="lg" role={role} className="mb-[14px] max-w-[780px]">
            <h2
                className={`m-0 mb-2 font-[family-name:var(--font-display)] text-[15px] font-semibold leading-[1.3] ${ink}`}
            >
                {title}
            </h2>
            <div className={`text-[14px] leading-[1.5] ${body}`}>{children}</div>
            {action ? <div className="mt-4 flex flex-wrap gap-2">{action}</div> : null}
        </Card>
    );
}
